import type { TransactionRecord } from 'app-components/flux/transactions/transactionsTypes';
import type RootState from 'app-components/utils/redux-store/rootState';

import { getAllowedCategoriesForAI, getCoaInfo } from '../../../tools/utils';
import type { RecategorizeAllowedCategory, RecategorizeEligibleTransaction } from './types';

export const buildRecategorizeAllowedCategories = (state: RootState): RecategorizeAllowedCategory[] =>
  getAllowedCategoriesForAI(state);

// Extension point (see CAPABILITY_TEMPLATE.md's "Batch specialization" section): batchBuilder.ts
// computes allowedCategories once per batch and passes the same array into every transaction's
// snapshot here, rather than each snapshot recomputing it.
export const buildRecategorizeEligibleSnapshot = (
  state: RootState,
  transactionId: string,
  txn: TransactionRecord,
  allowedCategories: RecategorizeAllowedCategory[],
): RecategorizeEligibleTransaction => {
  const coaInfo = getCoaInfo(state, txn.coa);

  return {
    transactionId,
    payee: txn.payee ?? '',
    date: txn.postedOn,
    amount: txn.amount,
    currentCategoryName: coaInfo.name,
    categoryId: coaInfo.id,
    allowedCategories,
  };
};
